export const PLYWOOD_APPROVAL_REQUEST = "PLYWOOD_APPROVAL_REQUEST";
export const PLYWOOD_APPROVAL_SUCCESS = "PLYWOOD_APPROVAL_SUCCESS";
export const PLYWOOD_APPROVAL_FAILED = "PLYWOOD_APPROVAL_FAILED";
